module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_co_cats_consumer_electronics_f25b447315bd277b00c235564e256d70.png";